<section class="main-content">
    <div class="container">
        <h1>{{labelConstant.welcome}}</h1>
        <p>{{labelConstant.firstPara}} <b>{{labelConstant.yogi}}</b>{{labelConstant.secondPara}}</p>
        <div class="row">
            <div class="col-lg-6 col-12" routerLink="/session">
                <div class="card mb-3">
                    <div class="card-body">
                        <img src="../../../assets/img/card-1.svg" class="img-fluid" alt="">
                        <h5>{{labelConstant.sessions}}</h5>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-12" routerLink="/events">
                <div class="card mb-3">
                    <div class="card-body">
                        <img src="../../../assets/img/card-2.svg" class="img-fluid" alt="">
                        <h5>{{labelConstant.events}}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>